// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ab-btn-outline-grey[data-v-0c4470d6],\n.outline-grey[data-v-0c4470d6] {\n  background-color: #fafafa;\n  border: #e2e2e2 solid 1px;\n  color: #11291b;\n}", ""]);
// Exports
module.exports = exports;
